import React, {useContext} from 'react';
import {Link, useParams} from 'react-router-dom';
import {Col, Form, Row, Button} from 'react-bootstrap';
import AuditContext from '../Utils/context.js';

export default function Evaluation() {

  const {employeeId} = useParams();
  const {schedule} = useContext(AuditContext);

  const getVariant = (form) => {

    if (form.SUBMIT_AT !== null) return 'primary';
    if (form.EVALUATE_AT !== null) return 'success';

    return 'secondary';
  }

  return (
    <>
      <h3>Desk Evaluation</h3>
      {/* {schedule.forms && schedule.forms.map((form, key) => (
        <Link to={`/auditee/${employeeId}/evaluations/${form.FORM_ID}`}>
          <Button variant={getVariant(form)}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
        </Link>
      ))} */}
      <Form.Group>
        <Row>
        {schedule.forms && schedule.forms.map((form, key) => (
        <Col key={key}  md={4}>
          <Link to={`/auditee/${employeeId}/evaluations/${form.FORM_ID}`}>
            <Button variant={getVariant(form)} style={{textAlign: 'left'}}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
          </Link>
        </Col>
          ))}
        </Row>
      </Form.Group>
    </>
  );
}